import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { layoutSelector } from './selector';

interface IState {
  loading: boolean;
  layoutType?: any;
  layoutSemiDarkType?: any;
  layoutSkintype?: any;
  layoutModeType?: any;
  layoutDirectionType?: any;
  layoutContentWidthType?: any;
  layoutSidebarSizeType?: any;
  layoutNavigationType?: any;
  layoutSidebarColorType?: any;
  layoutTopbarColorType?: any;
  layoutSidebarVisible?: boolean;
  activePath?: string;
}

export const LayoutHook = () => {
  const layout = useSelector(layoutSelector.getLayout);

  const [state, setState] = useState<IState>({
    loading: layout.loading,
    layoutType: layout.layoutType,
    layoutSemiDarkType: layout.layoutSemiDarkType,
    layoutSkintype: layout.layoutSkintype,
    layoutModeType: layout.layoutModeType,
    layoutDirectionType: layout.layoutDirectionType,
    layoutContentWidthType: layout.layoutContentWidthType,
    layoutSidebarSizeType: layout.layoutSidebarSizeType,
    layoutNavigationType: layout.layoutNavigationType,
    layoutSidebarColorType: layout.layoutSidebarColorType,
    layoutTopbarColorType: layout.layoutTopbarColorType,
    layoutSidebarVisible: layout.layoutSidebarVisible,
    activePath: layout.activePath,
  });

  useEffect(() => {
    setState({
      loading: layout.loading,
      layoutType: layout.layoutType,
      layoutSemiDarkType: layout.layoutSemiDarkType,
      layoutSkintype: layout.layoutSkintype,
      layoutModeType: layout.layoutModeType,
      layoutDirectionType: layout.layoutDirectionType,
      layoutContentWidthType: layout.layoutContentWidthType,
      layoutSidebarSizeType: layout.layoutSidebarSizeType,
      layoutNavigationType: layout.layoutNavigationType,
      layoutSidebarColorType: layout.layoutSidebarColorType,
      layoutTopbarColorType: layout.layoutTopbarColorType,
      layoutSidebarVisible: layout.layoutSidebarVisible,
      activePath: layout.activePath,
    });
  }, [layout]);

  return state;
};
